import { Settings } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const SettingsIcon = DeckardIconWrapper({ Icon: Settings });
